import { SyncFunFacts } from '@/components/molecules/SyncFunFacts';
import LinkingBannersCarousel from './LinkingBannersCarousel';
import QuizEngine from './engines/QuizEngine';
import MemoramaEngine from './engines/MemoramaEngine';
import SlideDeckPlayer from './engines/SlideDeckPlayer';
import CazaFacturas from './engines/CazaFacturas';
import { QUIZ_BANKS } from './content/quizBanks';
import { MEMORAMA_DECKS } from './content/memoramaDecks';
import { SLIDE_DECKS } from './content/slideDecks';
import type { WaitingVariant } from './waitingVariants';

// Registro único de variantes de la waiting experience:
// - Agregar CONTENIDO a una variante (preguntas, pares, slides) → content/*.
// - Agregar una VARIANTE nueva → suma el id a WAITING_VARIANTS y registra aquí
//   su label + componente (el Record fuerza la entrada en compilación).
// Los componentes se declaran a nivel de módulo para que su identidad sea
// estable entre renders — un arrow inline remontaría el juego a media partida.

const QuizVariant = () => <QuizEngine banks={QUIZ_BANKS} />;
const MemoramaVariant = () => <MemoramaEngine decks={MEMORAMA_DECKS} />;
const SlidesVariant = () => <SlideDeckPlayer decks={SLIDE_DECKS} />;

type VariantDefinition = {
	label: string;
	Component: () => React.JSX.Element;
};

export const VARIANT_REGISTRY: Record<WaitingVariant, VariantDefinition> = {
	banners: { label: 'Banners', Component: LinkingBannersCarousel },
	quiz: { label: 'Quiz', Component: QuizVariant },
	did_you_know: { label: '¿Sabías que?', Component: SyncFunFacts },
	minigame: { label: 'Memorama', Component: MemoramaVariant },
	caza_facturas: { label: 'Caza facturas', Component: CazaFacturas },
	slides: { label: 'Slides', Component: SlidesVariant },
};
